module.exports = __webpack_public_path__ + "img/img_banner_1_big.fc34549b.svg";